<script setup>
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';
import Label from 'dashboard/components-next/label/Label.vue';
import { computed } from 'vue';

// Kanal basina marka rengi.
//
// Tailwind siniflari TAM METIN yaziliyor: derleyici kaynagi tarayip
// sinif uretiyor, 'bg-' + degisken gibi birlestirmeler uretimde
// kayboluyor. Anahtar ikon adi - kanal anahtari bu bilesene
// gelmiyor, ikon zaten kanali birebir belirliyor.
const VURGULAR = {
  'i-woot-website': ['bg-n-blue-9/10', 'text-n-blue-11'],
  'i-woot-messenger': ['bg-n-blue-9/10', 'text-n-blue-11'],
  'i-woot-whatsapp': ['bg-n-teal-9/10', 'text-n-teal-11'],
  'i-woot-sms': ['bg-n-amber-9/10', 'text-n-amber-11'],
  'i-woot-mail': ['bg-n-ruby-9/10', 'text-n-ruby-11'],
  'i-woot-telegram': ['bg-n-blue-9/10', 'text-n-blue-11'],
  'i-woot-line': ['bg-n-teal-9/10', 'text-n-teal-11'],
  'i-woot-instagram': ['bg-n-ruby-9/10', 'text-n-ruby-11'],
  'i-woot-tiktok': ['bg-n-slate-9/10', 'text-n-slate-12'],
  'i-woot-api': ['bg-n-slate-9/10', 'text-n-slate-11'],
  'i-woot-voice': ['bg-n-amber-9/10', 'text-n-amber-11'],
  'i-lucide-megaphone': ['bg-n-teal-9/10', 'text-n-teal-11'],
};

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    required: true,
  },
  isComingSoon: {
    type: Boolean,
    default: false,
  },
  isBeta: {
    type: Boolean,
    default: false,
  },
  hasVoiceBadge: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const vurgu = computed(() => VURGULAR[props.icon] || ['bg-n-alpha-2', 'text-n-slate-10']);
const vurguZemin = computed(() => vurgu.value[0]);
const vurguRenk = computed(() => vurgu.value[1]);
</script>

<template>
  <button
    class="relative bg-n-solid-1 gap-3 cursor-pointer rounded-2xl flex flex-col justify-start transition-all duration-200 ease-in -m-px py-5 px-5 items-start border border-solid border-n-weak"
    :class="{
      'hover:enabled:border-n-blue-9 hover:enabled:shadow-md disabled:opacity-60 disabled:cursor-not-allowed':
        !isComingSoon,
      'cursor-not-allowed disabled:opacity-80': isComingSoon,
    }"
  >
    <!-- Ikon basligin SOLUNDA ve marka renginde. Eskiden sekiz gri
         daire alt alta duruyordu ve kanallar birbirinden ayirt
         edilemiyordu. -->
    <div class="flex items-center gap-3 w-full min-w-0">
      <div class="relative shrink-0">
        <div
          class="flex size-10 items-center justify-center rounded-full"
          :class="vurguZemin"
        >
          <Icon :icon="icon" class="size-6" :class="vurguRenk" />
        </div>
        <div
          v-if="hasVoiceBadge"
          class="absolute -top-1 ltr:-right-1 rtl:-left-1 flex size-4 items-center justify-center rounded-full bg-n-alpha-2 ring-2 ring-n-solid-1"
        >
          <Icon icon="i-lucide-audio-lines" class="text-n-slate-10 size-2.5" />
        </div>
      </div>
      <div class="flex items-center gap-2 min-w-0">
        <h3 class="text-n-slate-12 text-sm text-start font-medium capitalize truncate">
          {{ title }}
        </h3>
        <Label
          v-if="isBeta && !isComingSoon"
          v-tooltip.top="t('GENERAL.BETA_DESCRIPTION')"
          :label="t('GENERAL.BETA')"
          color="blue"
          compact
        />
      </div>
    </div>

    <p class="text-n-slate-11 text-start text-sm">
      {{ description }}
    </p>

    <div
      v-if="isComingSoon"
      class="absolute inset-0 flex items-center justify-center backdrop-blur-[2px] rounded-2xl bg-gradient-to-br from-n-surface-1/90 via-n-surface-1/70 to-n-surface-1/95 cursor-not-allowed"
    >
      <span class="text-n-slate-12 font-medium text-sm">
        {{ t('CHANNEL_SELECTOR.COMING_SOON') }} 🚀
      </span>
    </div>
  </button>
</template>
